<mat-card appearance="outlined" *ngIf="overview as deliveryNote">
  <mat-card-title class="tw-flex tw-justify-between">
    <div [ngStyle]="{ display: overview?.shippingIcon === shippingIcon.Store ? 'flex' : 'unset' }" class="tw-flex">
      <ui-svg-icon
        *ngIf="overview?.shippingIcon !== shippingIcon.Store; else storeShippingIcon"
        [name]="overview?.shippingIcon ? shippingIconList[overview.shippingIcon] : iconNames.TruckSizeL"
        [width]="32"
        class="tw-mr-4"
      ></ui-svg-icon>
      <ng-template #storeShippingIcon>
        <ui-svg-icon
          *ngIf="overview?.shippingIcon === shippingIcon.Store"
          [name]="iconNames.Store"
          [width]="32"
        ></ui-svg-icon>
      </ng-template>
      <span class="mat-card-title__title">
        {{ 'common.field.mainInfo' | translate }}
      </span>
    </div>
    <ui-deviation-type
      *ngIf="deliveryNote?.deliveryDeviation"
      [deviation]="deliveryDeviation"
      [showInTimeDeviation]="true"
      [showTooltipValue]="deliveryNote?.deliveryDeviation.type !== type.InTime"
    ></ui-deviation-type>
  </mat-card-title>

  <mat-card-content class="main-info">
    <ui-info-field-item
      [label]="'publicTracking.mainInfo.deliveryNoteNumber' | translate"
      [text]="deliveryNoteNumber"
      [cropTextNeeded]="true"
    >
    </ui-info-field-item>
    <ui-info-field-item [label]="'common.field.origin' | translate" [text]="deliveryNote?.origin"></ui-info-field-item>
    <ui-info-field-item
      [class.main-info__destination-full]="!deliveryNote?.carrierName && !deliveryNote?.trackingId"
      [label]="'publicTracking.mainInfo.destination' | translate"
      [text]="deliveryNote?.destinationAddress"
    >
    </ui-info-field-item>
    <ui-info-field-item
      *ngIf="deliveryNote?.carrierName"
      [class.main-info__carrier-name-full]="!deliveryNote?.trackingId"
      [label]="'common.field.carrierName' | translate"
      [text]="deliveryNote?.carrierName"
    >
    </ui-info-field-item>
    <ui-info-field-item
      *ngIf="deliveryNote?.trackingId"
      [class.main-info__carrier-id-full]="!deliveryNote?.carrierName"
      [label]="'common.field.trackingId' | translate"
      [text]="deliveryNote?.trackingId"
    >
    </ui-info-field-item>
    <ui-info-field-item
      *ngIf="deliveryNote.estimatedArrivalTime"
      [label]="'common.list.th.estimatedArrivalTime' | translate"
      [text]="deliveryNote.estimatedArrivalTime | date : dateFormat | nullToNotAvailable"
    >
    </ui-info-field-item>
    <ui-info-field-item
      [label]="'publicTracking.mainInfo.totalWeight' | translate"
      [text]="
        deliveryNote?.weight?.value ? deliveryNote?.weight?.value + ' ' + deliveryNote?.weight?.unit : notAvailable
      "
    >
    </ui-info-field-item>
    <ui-info-field-item
      [label]="'publicTracking.mainInfo.totalVolume' | translate"
      [text]="
        deliveryNote?.volume?.value ? deliveryNote?.volume?.value + ' ' + deliveryNote?.volume?.unit : notAvailable
      "
    >
    </ui-info-field-item>
    <ui-info-field-item
      *ngIf="deliveryNote?.shippingCondition"
      [label]="'publicTracking.mainInfo.shippingCondition' | translate"
      [text]="deliveryNote?.shippingCondition"
    ></ui-info-field-item>
    <ui-info-field-item
      *ngIf="deliveryNote?.reason"
      [label]="'publicTracking.mainInfo.statusWarning' | translate"
      [text]="deliveryNote?.reason"
      class="status-warning"
    >
    </ui-info-field-item>
  </mat-card-content>
</mat-card>
